import React, { useState, useEffect } from "react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../modal.css";

import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Badge from "@mui/material/Badge";
import { Button } from "react-bootstrap";

import TableSmall from "./../Theme/TableSmall.js";
import AddAgent from "./AddAgent";
import EditAgent from "./EditAgent";
import DeleteConfirmation from "../deleteConfirmation";
import Add from "../Drivers/Add";
import { Checkbox, Modal } from "antd";
import { handleExportClickDriver } from "../exportDriverFile";
import ActionButtons from "./AgentActionButtons.js";

import Spinner from "../Spinner";

import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { 
  Edit as EditIcon, 
  Delete as DeleteIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';



const Agent = ({ socket }) => {
  const edit = "agentDetails";
  const detail = "sub-agent";
  const [id, setId] = useState(null);

  const showEditModal = (id) => {
    setId(id);

    axios
      .get("/agent/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
          // Other headers if required
        },
      })
      .then((res) => {
        setData(res.data.agent);

        setDisplayEditModal(true);
      });
  };
  const [displayEditModal, setDisplayEditModal] = useState(false);
  const [data, setData] = useState(null);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [loading, setLoading] = useState(true);
    
  const hideAddModal = () => {
    setDisplayAddModal(false);
  };
  const hideEditModal = () => {
    setDisplayEditModal(false);
  };

  const showDeleteModal = (id, name) => {
    setId(id);
    setDeleteMessage(`Are you sure you want to delete this agent`);
    setDisplayConfirmationModal(true);
  };


  const navigate = useNavigate();

 
  
  const columns = React.useMemo(
    () => [
      {
        Header: "Agent Information",
        columns: [
          {
            Header: "ID",
            accessor: "id",
            disableFilters: true,
          },
          {
            Header: "Name",
            accessor: "name",
            disableFilters: true,
          },
          {
            Header: "Phone",
            accessor: "phone",
            disableFilters: true,
          },
          {
            Header: "Email",
            accessor: "email",
            disableFilters: true,
          },
        ],
      },
      {
        Header: " ",
        columns: [
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,
            Cell: (row) => {
              const status = row.cell.row.original.status || "Active";
              return (
                <Chip 
                  label={status} 
                  color={status === "Active" ? "success" : "warning"}
                  variant="filled"
                  sx={{
                    fontWeight: 'bold',
                    borderRadius: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    boxShadow: status === "Active" 
                      ? '0 2px 4px rgba(0,255,0,0.2)' 
                      : '0 2px 4px rgba(255,165,0,0.2)'
                  }}
                />
              );
            },
          },
          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div style={{ 
                display: "flex", 
                gap: "15px", 
                alignItems: 'center' 
              }}>
                <Tooltip title="Edit Agent">
                  <span>
                    <EditIcon 
                      color="primary" 
                      sx={{ 
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                        '&:hover': {
                          transform: 'scale(1.2)',
                          color: '#1e40af'
                        }
                      }}
                      onClick={() => showEditModal(row.cell.row.original.id)}
                    />
                  </span>
                </Tooltip>
                
                <Tooltip title="Delete Agent">
                  <span>
                    <DeleteIcon 
                      color="error" 
                      sx={{ 
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                        '&:hover': {
                          transform: 'scale(1.2)',
                          color: '#ff0000'
                        }
                      }}
                      onClick={() => showDeleteModal(row.cell.row.original.id)}
                    />
                  </span>
                </Tooltip>
                
                <Tooltip title="View Agent Details">
                  <span>
                    <VisibilityIcon 
                      color="success" 
                      sx={{ 
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                        '&:hover': {
                          transform: 'scale(1.2)',
                          color: '#16a34a'
                        }
                      }}
                      onClick={() => navigate(`/${detail}/${row.cell.row.original.id}`)}
                    />
                  </span>
                </Tooltip>
              </div>
            ),
          },
        ],
      },
    ],
    []
  );


  const columns_expo = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Name",
        accessor: "name",
        disableFilters: true,
      },
      {
        Header: "Phone",
        accessor: "phone",
        disableFilters: true,
      },
      {
        Header: "Email",
        accessor: "email",
        disableFilters: true,
      },

      {
        Header: "Status",
        accessor: "status",
      },
    ],
    []
  );

  const notify = () =>
    toast.success("Agent list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  useEffect(() => {
    getAgents();
  }, []);

  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [agents, setAgents] = useState([]);

  const getAgents = async () => {
    const response = await axios
      .get("agents/", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
          // Other headers if required
        },
      })
      .then(notify());
    setLoading(false);


    setAgents(response.data);
  };

  const showAddModal = () => {
    setDisplayAddModal(true);
  };

  const submitDelete = (id) => {
    console.log(id);
    deleteAgent(id);
    setDisplayConfirmationModal(false);
  };
  const deleteAgent = async (id) => {
    const response = await axios.delete("/agent/" + id, {
      data: { id: id },
    });
    getAgents();
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const [selectedColumns, setSelectedColumns] = useState(
    columns_expo.map((column) => column.Header)
  );

  const handleOkModal = () => {
    console.log("handleOkModal called");
    setIsModalVisible(false);
    handleExportClickDriver(
      agents,
      columns_expo,
      selectedColumns,
      "Agents",
      "agent_list.pdf"
    );
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // Inside your component
  function handleColumnToggle(columnHeader) {
    setSelectedColumns((prevSelectedColumns) => {
      if (prevSelectedColumns.includes(columnHeader)) {
        return prevSelectedColumns.filter((col) => col !== columnHeader);
      } else {
        return [...prevSelectedColumns, columnHeader];
      }
    });
  }

  return (
    <div className="content-wrappers" style={{ marginTop: '-60px' }}>
    <div className="content-wrappers">
      <ToastContainer />
      <br />
      <br />
      <br />
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-6">
              <div className="card">
               
              <ActionButtons title="Agents "
               showModal={showModal} showAddModal={showAddModal}/>
                    <Modal
                     style={{marginTop: "60px"}} 
                      title="Select Columns to Export"
                      visible={isModalVisible}
                      onOk={handleOkModal}
                      onCancel={handleCancel}
                      footer={[
                        <Button key="cancel" onClick={handleCancel}>
                          Cancel
                        </Button>,
                        <Button
                          style={{ marginLeft: "10px" }}
                          key="ok"
                          type="primary"
                          onClick={handleOkModal}
                        >
                          OK
                        </Button>,
                      ]}
                    >
                      <div style={{ marginBottom: "20px" }}>
                        {columns_expo.map((column) => (
                          <div
                            key={column.Header}
                            style={{ marginBottom: "10px" }}
                          >
                            <Checkbox
                              checked={selectedColumns.includes(column.Header)}
                              onChange={() => handleColumnToggle(column.Header)}
                              style={{ marginRight: "10px", fontSize: "16px" }}
                            >
                              {column.Header}
                            </Checkbox>
                          </div>
                        ))}
                      </div>
                    </Modal>

                <div className="card-body">
                {loading ? (
                    <Spinner />
                  ) : (
                  <TableSmall
                    columns={columns}
                    data={agents}
                    edit={edit}
                    detail={detail}
                  />
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        id={id}
        message={deleteMessage}
      />
      <AddAgent
        getAgents={getAgents}
        showModal={displayAddModal}
        hideModal={hideAddModal}
      />
      {displayEditModal == true && (
        <EditAgent
          getAgents={getAgents}
          id={id}
          data={data}
          showModal={displayEditModal}
          hideModal={hideEditModal}
        />
      )}
      </div>
    </div>
  );
};

export default Agent;
